import {Photo} from "./Photo";
import {Type} from "./Type";
import {Option} from "./Option";
export class Product {
    id: number;
    name: string;
    photo: Photo;
    description: string;
    type: Type;
    stock: number;
    comment: string;
    option: Option;
    active: boolean;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/Product.ts